"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = Wizard;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _set = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/set"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _Stepper = _interopRequireDefault(require("@material-ui/core/Stepper"));

var _Step = _interopRequireDefault(require("@material-ui/core/Step"));

var _StepLabel = _interopRequireDefault(require("@material-ui/core/StepLabel"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _GenericStore = require("../store/GenericStore");

var _WizardStep = _interopRequireDefault(require("./WizardStep"));

var _reactI18next = require("react-i18next");

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      width: '100%'
    },
    button: {
      marginRight: theme.spacing(1)
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    }
  };
});

function getSteps(block) {
  var steps = (0, _keys["default"])(block.content);
  return steps;
}

function Wizard(props) {
  var block = props.block,
      parentPath = props.parentPath;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var classes = useStyles();

  var _React$useState = _react["default"].useState(0),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      activeStep = _React$useState2[0],
      setActiveStep = _React$useState2[1];

  var _React$useState3 = _react["default"].useState(new _set["default"]()),
      _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
      skipped = _React$useState4[0],
      setSkipped = _React$useState4[1];

  var activeStepContent = {}; // .filter((obj)=>obj.step===activeStep)

  for (var step in block.content) {
    if (block.content[step].step === activeStep) {
      activeStepContent = block.content[step];
      console.log('activeStepContent: ', activeStepContent);
    }
  }

  var steps = getSteps(block);

  var isStepOptional = function isStepOptional(step, block) {
    var stepObj = {};

    for (var o in block.content) {
      if (block.content[o].step === step) stepObj = block.content[o];
    }

    return stepObj.hasOwnProperty('isOptional') && stepObj.isOptional;
  };

  var isStepSkipped = function isStepSkipped(step) {
    return skipped.has(step);
  };

  var handleNext = function handleNext() {
    var newSkipped = skipped;

    if (isStepSkipped(activeStep)) {
      newSkipped = new _set["default"](newSkipped.values());
      newSkipped["delete"](activeStep);
    }

    setActiveStep(function (prevActiveStep) {
      return prevActiveStep + 1;
    });
    setSkipped(newSkipped);
  };

  var handleBack = function handleBack() {
    setActiveStep(function (prevActiveStep) {
      return prevActiveStep - 1;
    });
  };

  var handleSkip = function handleSkip() {
    if (!isStepOptional(activeStep, block)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep(function (prevActiveStep) {
      return prevActiveStep + 1;
    });
    setSkipped(function (prevSkipped) {
      var newSkipped = new _set["default"](prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  var handleReset = function handleReset() {
    setActiveStep(0);
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react["default"].createElement(_Stepper["default"], {
    activeStep: activeStep
  }, steps.map(function (key, index) {
    var stepProps = {};
    var labelProps = {};

    if (isStepOptional(index, block)) {
      labelProps.optional = /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        variant: "caption"
      }, "Optional");
    }

    if (isStepSkipped(index)) {
      stepProps.completed = false;
    }

    return /*#__PURE__*/_react["default"].createElement(_Step["default"], (0, _extends2["default"])({
      key: key
    }, stepProps), /*#__PURE__*/_react["default"].createElement(_StepLabel["default"], labelProps, t(block.content[key].label)));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: '100%',
      textAlign: 'center',
      marginTop: '40px'
    }
  }, activeStep === steps.length ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    className: classes.instructions
  }, "All steps completed - you're finished"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: handleReset,
    className: classes.button
  }, "Reset")) : /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    className: classes.instructions
  }, /*#__PURE__*/_react["default"].createElement(_WizardStep["default"], {
    block: activeStepContent,
    step: activeStep
  })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    disabled: activeStep === 0,
    onClick: handleBack,
    className: classes.button
  }, "Back"), isStepOptional(activeStep, block) && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    variant: "contained",
    color: "primary",
    onClick: handleSkip,
    className: classes.button
  }, "Skip"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    variant: "contained",
    color: "primary",
    onClick: handleNext,
    className: classes.button
  }, activeStep === steps.length - 1 ? 'Finish' : 'Next')))));
}